var _circle, _circle2, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 1.25,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 9,
    r: 1.25,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 15.5C15 16.8807 13.6569 18 12 18C10.3431 18 9 16.8807 9 15.5C9 14.1193 10.3431 13 12 13C13.6569 13 15 14.1193 15 15.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7747 5.71368V4.76804H19.2132C18.6096 4.76804 18.0979 5.17637 18.0125 5.7261C17.8994 6.45447 18.5701 7.08241 19.3637 6.99115L19.5719 6.96721C20.2591 6.88819 20.7747 6.35078 20.7747 5.71368Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7747 2.32155V4.76804M20.7747 2.32155L22.5897 2.05082C22.5913 2.05058 22.5921 2.05045 22.5928 2.05037C22.5934 2.05028 22.5959 2.04998 22.6007 2.04939C22.6106 2.04817 22.6309 2.04513 22.6368 2.04C22.6446 2.03313 22.6474 2.0205 22.653 2L22.9872 1.09148C22.9997 1.0456 23.0059 1.02266 22.9923 1.00903C22.9786 0.995397 22.9532 0.999284 22.9025 1.00706L22.0226 1.14197C21.4267 1.23335 21.1287 1.27904 20.9517 1.47121C20.7747 1.66338 20.7747 1.7657 20.7747 2.32155ZM20.7747 4.76804V5.71368C20.7747 6.35078 20.2591 6.88819 19.5719 6.96721L19.3637 6.99115C18.5701 7.08241 17.8994 6.45447 18.0125 5.7261C18.0979 5.17637 18.6096 4.76804 19.2132 4.76804H20.7747Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 10.7306 22.785 9.51144 22.3894 8.37692C21.9337 8.91343 21.3554 9.35484 20.6877 9.64119C20.8913 10.393 21 11.1838 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C13.3535 3 14.6372 3.29878 15.7888 3.83397C16.1721 3.19906 16.7149 2.69149 17.3254 2.37273C15.7475 1.49804 13.9319 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.1eaee9ee8007f0e6612e0865efb7339f.svg";
export { ForwardRef as ReactComponent };